import { Stack } from '@mui/material';
import { CardSkeletonProps, SKELETON_TEXT_HEIGHT } from '../Skeleton.types';
import { SkeletonText } from './SkeletonText';

export const CardSkeleton = ({ sx }: CardSkeletonProps) => {
    return (
        <Stack spacing={1} sx={{ width: 320, ...sx }}>
            <SkeletonText width={120} height={SKELETON_TEXT_HEIGHT} />
            <SkeletonText width="100%" height={SKELETON_TEXT_HEIGHT} />
            <SkeletonText width="100%" height={SKELETON_TEXT_HEIGHT} />
        </Stack>
    );
};
